import { Box } from '@hiiretail/react-foundation-ui';
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { NewReceipt } from 'NewReceipt/NewReceipt';
import './index.css';

const { PUBLIC_URL } = process.env;

export const App: React.FC = () => (
  <Router basename={PUBLIC_URL}>
    <Box alignItems="center" justifyContent="center" height="100%">
      <Routes>
        <Route path="/" element={<NewReceipt />} />
      </Routes>
    </Box>
  </Router>
);
